var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{class:{ imgLoading: _vm.load },attrs:{"src":_vm.imgSrc,"loading":_vm.loading,"draggable":_vm.draggable},on:{"error":_vm.onError,"load":_vm.onLoad}})
}
var staticRenderFns = []

export { render, staticRenderFns }